import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-motivational-coaching',
  templateUrl: './motivational-coaching.component.html',
  styleUrls: ['./motivational-coaching.component.scss']
})
export class MotivationalCoachingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
